<template>
  <div>

<b-navbar toggleable="md" type="light" variant="light">

  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

  <b-navbar-brand to="/"><img src="../assets/cyberhaltestelle_monitor.png" height="30"></b-navbar-brand>

  <b-collapse is-nav id="nav_collapse">

    <b-navbar-nav>
      <b-nav-item to="/">Home</b-nav-item>
      <b-nav-item to="/page/einstellungen">Monitor</b-nav-item>
      <!--<b-nav-item to="/page/tech">Weitere Informationen</b-nav-item>-->
    </b-navbar-nav>

    <b-navbar-nav class="ml-auto" right>
      <b-nav-item to="/page/impressum">Impressum</b-nav-item>
    </b-navbar-nav>

  </b-collapse>
</b-navbar>

    <main>
      <video playsinline autoplay muted loop poster="../assets/standbild.png" class="bgvid">
          <source src="../assets/bahnhof_hintergrund.mp4" type="video/mp4">
      </video>

      <div class="container">
        <div class="row main">
          <div class="col-12 align-middle main-content">
            <router-view></router-view>
          </div>
        </div>
      </div>

    </main>
  </div>
</template>

<script>

export default {
  name: 'Page'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.bgvid {
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -100;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    background: url(../assets/standbild.png) no-repeat;
    background-size: cover;

  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
}

.main {
    display: flex;
    align-items: center;
    text-align: center;
}

.row {
    min-height: 80%;  /* Fallback for browsers do NOT support vh unit */
    min-height: 80vh; /* These two lines are counted as one :-)       */
    position: static;
    align-items: center;
}

.align-middle {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
}

.main-content {
  min-height: 600px;
}

</style>
